import { useMutationWithResultNotification } from 'api/mutations/useMutationWithResultNotification';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { IAssignmentUpsertBody } from 'interfaces/assessmentForms';
import { organizationContextAddFormAssignment } from 'api/graspManagement';
import { IMutationProps } from '../../../../interfaces/ui';

interface IAddAssignment
  extends Omit<
    IAssignmentUpsertBody,
    'userId' | 'contextType' | 'contextObjectId' | 'dateFrom'
  > {
  dateFrom?: Date;
}

type useOrganizationContextAddFormAssignmentParams = {
  organizationId: string;
  caseId: string;
  timelineId: string;
  userId: string;
};

const useOrganizationContextAddFormAssignment = (
  params: useOrganizationContextAddFormAssignmentParams,
  options: IMutationProps
) => {
  return useMutationWithResultNotification<IAddAssignment, void>({
    asyncApiFunction: async ({
      dateTo,
      dateFrom,
      formCode,
      scheduleInfo,
      isEditableByOrganizationMembers,
      activeHoursAfter,
      activeHoursBefore,
    }) => {
      await organizationContextAddFormAssignment(
        params.organizationId,
        params.timelineId,
        params.userId,
        formCode,
        params.caseId,
        scheduleInfo,
        dateTo,
        isEditableByOrganizationMembers,
        activeHoursBefore,
        activeHoursAfter,
        dateFrom
      );
    },
    onSuccess: () => {
      displaySuccessNotification('CaseDetails.assignmentUpdateSuccess');

      if (options.successFb) options.successFb();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'CaseDetails.assignmentUpdateError'
      );

      if (options.errorFb) options.errorFb();
    },
    resetOnResult: true,
  });
};

export default useOrganizationContextAddFormAssignment;
